import { UrlTrackingConfig } from './types';

export const CACHE_KEYS = {
  PROFILE_DATA: 'tronic_cached_profile_data',
  LEVEL_DATA: 'tronic_cached_level_data',
  BRANDING_DATA: 'tronic_cached_branding_data',
  CHANNEL_DATA: 'tronic_cached_channel_data',
  AUTH_STATE: 'tronic_cached_auth_state',
  IFRAME_AUTH_FLAG: 'tronic_iframe_auth_received',
  RECOMMENDATION_DATA: 'tronic_cached_recommendation_data',
} as const;

export const CACHE_EXPIRATION_MS = 5 * 60 * 1000;

export const URL_TRACKING_CONFIG: UrlTrackingConfig = {
  debounceMs: 300,
  maxKeywords: 20,
};

export const CONTENT_CACHE_EXPIRY = 5 * 60 * 1000; // 5 minutes
